import React from "react";
import {rulesInfo} from "../constants/const";
import RulesItem from "../components/RulesItem";


function Rules () {
    return (
        <div className="rules">
            <div className="rules_title">
                Правила
            </div>
            {rulesInfo.map((item,index) => {
                return (
                    <RulesItem
                        index={index}
                        title={item.title}
                        icon={item.icon}
                        content_1={item.content_1}
                        content_2={item.content_2}
                        content_3={item.content_3}
                    />
                )
                })}
        </div>
    )
}

export default Rules